module.exports = __webpack_public_path__ + "static/media/SAVINGS_NIGHT.b0d0ccbd.png";